import React from "react";
import "./work.css";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react/dist/iconify.js";

const capabilities = [
  { label: "Responsive Design", icon: "mdi:tablet-cellphone" },
  { label: "UI/UX Design", icon: "mdi:palette-outline" },
  { label: "API Integration", icon: "mdi:api" },
  { label: "Maintenance & Support", icon: "mdi:tools" },
  { label: "SEO", icon: "mdi:magnify" },
  { label: "E-Commerce", icon: "mdi:cart-outline" },
];

const Work = () => {
  const transition = { duration: 1, type: "spring" };

  return (
    <div className="work">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={transition}
        className="left"
      >
        <span className="section-eyebrow">Development</span>
        <h2 className="workHeading">
          Solutions Built for Brands & Clients
        </h2>
        <span className="workText">
          I partner with brands and clients to build products end to end — from
          first wireframe to production deployment. Every engagement is scoped
          around real business value, not just shipped code.
        </span>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ ...transition, delay: 0.1 }}
        className="w-right"
      >
        {capabilities.map((capability) => (
          <div className="w-icon" key={capability.label}>
            <Icon icon={capability.icon} className="w-icon-svg" />
            <span className="w-icon-label">{capability.label}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default Work;
